/**
 * Lazy Loading com Retry - Trata ChunkLoadError com reload controlado
 * Evita tela branca após deploy quando chunks mudam
 */

import { lazy, ComponentType } from 'react';
import { safeSessionStorage } from './safeStorage';

const RETRY_KEY = '__chunk_retry__';
const MAX_RETRIES = 1;

function isChunkLoadError(error: unknown): boolean {
  if (!(error instanceof Error)) return false;
  
  const message = error.message.toLowerCase();
  return (
    message.includes('loading chunk') ||
    message.includes('failed to fetch dynamically imported module') ||
    message.includes('loading css chunk') ||
    error.name === 'ChunkLoadError'
  );
}

export function lazyWithRetry<T extends ComponentType<unknown>>(
  importer: () => Promise<{ default: T }>
): React.LazyExoticComponent<T> {
  return lazy(async () => {
    try {
      const mod = await importer();
      // Limpa a flag APENAS após um import bem-sucedido (evita loop infinito de reload)
      safeSessionStorage.removeItem(RETRY_KEY);
      return mod;
    } catch (error: unknown) {
      if (isChunkLoadError(error)) {
        const retryCount = parseInt(safeSessionStorage.getItem(RETRY_KEY) || '0', 10);

        
        if (retryCount < MAX_RETRIES) {
          // Marcar retry e recarregar página
          safeSessionStorage.setItem(RETRY_KEY, String(retryCount + 1));
          console.warn('[LazyWithRetry] ChunkLoadError detectado, recarregando página...');
          window.location.reload();
          
          // Nunca resolve (reload em andamento)
          return new Promise(() => {});
        } else {
          // Limpar contador e deixar ErrorBoundary tratar
          safeSessionStorage.removeItem(RETRY_KEY);
          console.error('[LazyWithRetry] ChunkLoadError persistente após retry');
          throw error;
        }
      }
      
      throw error;
    }
  });
}

// Limpar flag manualmente (mantido para compatibilidade)
export function clearChunkRetryFlag(): void {
  safeSessionStorage.removeItem(RETRY_KEY);
}

